import React, { useEffect, useRef } from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from "react-redux";

import '../style/videoModal.less';



interface VideoModalProps {
    visible: boolean; // 显隐
    onFinish: () => void; // 窗口关闭回调
    item: any; // 包含视频的视频美学的某一项数据
}


/**
 * 视觉美学视频弹窗
 */
const VideoModal = (props: VideoModalProps) => {

    const { visible, onFinish, item } = props;
    const { coverImage, title, videoDescription, videoUrl } = item || {};
    const { isMobile } = useSelector((state: any) => state.reducer);

    const videoRef = useRef<any>(null);



    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.play();
        }
    }, [videoRef.current]);


    return (
        <Modal
            width={window.innerWidth > 1200 ? 1200 : 'auto'}
            visible={visible}
            centered
            onCancel={onFinish}
            wrapClassName="custom-video-modal-wraaper"
        >   
            <div className="h54 flexic pl12 custom-video-header">{title}</div>
            <div className="flexic flexjc custom-video-container" style={{height: isMobile ? 'auto' : 640}}>
                <video ref={videoRef} controls src={videoUrl} muted={true} loop={true} autoPlay={false}>
                    <source src={videoUrl} type="video/mp4" />
                    您的浏览器不支持视频标签。
                </video>
            </div>
            <div className="flexic p12 custom-video-footer">{videoDescription}</div>
        </Modal>
    );
};


export { VideoModal };